module.exports = __webpack_public_path__ + "static/img/us-2.bde1a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactpic/us-2.jpg
// module id = zHPb
// module chunks = 52